import Cookies from "js-cookie";
import { commonConstants } from "../_redux/_constants/index";

export const getRequestHeader = (method) => {
  return authHeader(method);
};

function authHeader(method) {
  if (method === commonConstants.REQUEST_HEADER_METHOD_POST) {
    return {
      "Content-Type": "application/json",
      "x-csrf-token": Cookies.get("XSRF-TOKEN"),
    };
  } else if (method === commonConstants.REQUEST_HEADER_METHOD_GET) {
    return {
      "Content-Type": "application/json",
      "x-csrf-token": Cookies.get("XSRF-TOKEN"),
    };
  } else if (method === commonConstants.REQUEST_HEADER_METHOD_UPLOAD) {
    return {
      "x-csrf-token": Cookies.get("XSRF-TOKEN"),
    };
  } else {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-csrf-token": Cookies.get("XSRF-TOKEN"),
    };
  }
}
